import { createAction, props } from '@ngrx/store';
import { CurrentUser, IUserProfile } from './current-user.model';

export const loadCurrentUser = createAction('[User] Load Current User');
export const loadCurrentUserSuccess = createAction(
  '[User] Load Current User Success',
  props<{ currentUser: CurrentUser }>()
);
export const loadCurrentUserFailure = createAction(
  '[User] Load Current User Failure',
  props<{ error: unknown; loading: boolean }>()
);

export const switchCountry = createAction(
  '[Users] Switch Country',
  props<{ countryId: number }>()
);

export const switchCountrySuccess = createAction(
  '[Users] Switch Country Success',
  props<{ user: IUserProfile }>()
);

export const switchCountryFailure = createAction(
  '[Users] Switch Country Failure',
  props<{ error: unknown }>()
);

export const switchLanguage = createAction(
  '[Users] Switch Language',
  props<{ language: string }>()
);

export const startImpersonation = createAction(
  '[Users] Start Impersonation',
  props<{ userId: number; userName: string }>()
);
export const startImpersonationSuccess = createAction(
  '[Users] Start Impersonation Success',
  props<{ userName: string }>()
);
export const startImpersonationFailure = createAction(
  '[Users] Start Impersonation Failure',
  props<{ error: unknown }>()
);
export const stopImpersonation = createAction('[Users] Stop Impersonation');
export const stopImpersonationSuccess = createAction(
  '[Users] Stop Impersonation Success'
);
export const stopImpersonationFailure = createAction(
  '[Users] Stop Impersonation Failure',
  props<{ error: unknown }>()
);
